import {
  REQUEST_EXCEPTIONS,
  RESPONSE_EXCEPTIONS,
  REQUEST_EXCEPTIONS_FAULURE,
  REQUEST_DELETE_EXCEPTIONS,
  RESPONSE_DELETE_EXCEPTIONS,
  REQUEST_DELETE_EXCEPTIONS_FAULURE,
} from "../actions/exceptionsActions";

import { states } from "./queriesStates";

const initialState = {
  exceptionsDataState: states.NOT_REQUESTED,
  exceptionsDeleteDataState: states.NOT_REQUESTED,
  exceptions: null,
};

const exceptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_EXCEPTIONS:
      return Object.assign({}, state, {
        exceptionsDataState: states.REQUEST,
      });
    case RESPONSE_EXCEPTIONS:
      return Object.assign({}, state, {
        exceptionsDataState: states.READY,
        exceptions: action.data,
      });
    case REQUEST_EXCEPTIONS_FAULURE:
      return Object.assign({}, state, {
        exceptionsDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DELETE_EXCEPTIONS:
      return Object.assign({}, state, {
        exceptionsDeleteDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_EXCEPTIONS:
      const exceptions = state.exceptions;

      exceptions.modules.forEach((module) => {
        if (module.id === action.data.id) {
          module.exceptions = [];
        }
      });

      return Object.assign({}, state, {
        exceptionsDeleteDataState: states.READY,
        exceptions: exceptions,
      });
    case REQUEST_DELETE_EXCEPTIONS_FAULURE:
      return Object.assign({}, state, {
        exceptionsDeleteDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default exceptionsReducer;
